import React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';

interface IDocumensoDeactivationModalProps {
    isOpen: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

// Same markup as ZammadDeactivationModal.
export const DocumensoDeactivationModal: React.FC<IDocumensoDeactivationModalProps> = ({ isOpen, onCancel, onConfirm }) => {
    return (
        <Dialog
            hidden={!isOpen}
            onDismiss={onCancel}
            dialogContentProps={{
                type: DialogType.normal,
                title: IvicosStrings.disableProviderDialogTitle.replace('{0}', IvicosStrings.documensoSettingsToggleLabel),
                subText: IvicosStrings.disableProviderDialogWarning.replace('{0}', IvicosStrings.documensoSettingsToggleLabel)
            }}
            modalProps={{ isBlocking: true, styles: { main: { maxWidth: '90vw', minWidth: 'min(320px, 90vw)' } } }}
        >
            <DialogFooter>
                <DefaultButton text={IvicosStrings.disableProviderDialogCancel} onClick={onCancel} />
                <DefaultButton
                    text={IvicosStrings.disableProviderDialogConfirm}
                    onClick={onConfirm}
                    data-test-id="documenso-deactivation-confirm"
                    styles={{
                        root: { backgroundColor: 'red', borderColor: 'red', color: 'white' },
                        rootHovered: { backgroundColor: '#cc0000', borderColor: '#cc0000', color: 'white' }
                    }}
                />
            </DialogFooter>
        </Dialog>
    );
};
